import { Paragraph, Typography } from '../../designComponents';
import { InfoRowStyled, VerticalSpaceStyled } from '../../style/reusableStyle';
import { ContractDetailsContainerStyled } from './style';
type JobInformationType = {
  createdAt: string;
  jobTitle: string;
  notes: string;
};

const JobInformation = ({ createdAt, jobTitle, notes }: JobInformationType) => {
  return (
    <ContractDetailsContainerStyled>
      <Typography
        variant="normal"
        className="section-title"
        fontColor="secondary"
        strong
      >
        JOB INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Job Created At :</Typography>
          <Typography className="value">{createdAt}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Job Title: </Typography>
          <Typography className="value">{jobTitle}</Typography>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Notes :</Typography>
          <Paragraph className="value" fontColor="primary" text={notes} />
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ContractDetailsContainerStyled>
  );
};
export default JobInformation;
